export function getNameInfo(name) {
    const url = new URL(name, 'ium:/');
    return {
        url,
        name: url.pathname.split('/').pop(),
        relativePath: url.pathname.slice(1),
    };
}
//# sourceMappingURL=getNameInfo.js.map